// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b9f03b96","466":"75deeeca","663":"6e9df0c2"}[chunkId] + ".chunk.js";
};